import React, { useState } from 'react';

export default function NamePet({ onCreate }) {
  const [name, setName] = useState('');
  const clean = name.trim().slice(0, 18);

  const submit = event => {
    event.preventDefault();
    if (clean.length < 2) return;
    onCreate(clean);
  };

  return (
    <main className="welcome-shell">
      <section className="welcome-card">
        <div className="egg-wrap" aria-hidden="true">
          <div className="egg-glow" />
          <div className="egg"><span /><span /><span /></div>
        </div>
        <div className="eyebrow">NOVÝ MAZLÍČEK</div>
        <h1>Něco uvnitř čeká.</h1>
        <p>Dej mu jméno. Od té chvíle je jeho přežití tvoje starost.</p>
        <form onSubmit={submit}>
          <label htmlFor="pet-name">Jméno mazlíčka</label>
          <div className="name-row">
            <input
              id="pet-name"
              autoFocus
              autoComplete="off"
              maxLength={18}
              value={name}
              onChange={event => setName(event.target.value)}
              placeholder="např. Momo"
            />
            <button type="submit" disabled={clean.length < 2}>Vylíhnout</button>
          </div>
        </form>
        <span className="storage-note">Všechna data zůstávají pouze v tomto zařízení.</span>
      </section>
    </main>
  );
}
